/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_FooterInputs */

const en_pronunciation_report_footer = /** @type {(inputs: Pronunciation_Report_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your correction helps improve narration.`)
};

const es_pronunciation_report_footer = /** @type {(inputs: Pronunciation_Report_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu corrección ayuda a mejorar la narración.`)
};

/**
* | output |
* | --- |
* | "Your correction helps improve narration." |
*
* @param {Pronunciation_Report_FooterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_footer = /** @type {((inputs?: Pronunciation_Report_FooterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_FooterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_footer(inputs)
	return en_pronunciation_report_footer(inputs)
});